<div
  class="font-ms truncate"
  *ngIf="params.data.rowType !== rowTypeMetric"
  [ngClass]="{
    '': params.data.rowType === rowTypeHeader
  }"
>
  <div
    class="flex max-w-min truncate"
    [ngClass]="{
      'hover:text-m500 cursor-pointer': params.data.rowType === rowTypeFormula
    }"
    (click)="showDialog($event)"
  >
    <m-row-metric-label
      [name]="params.value"
      [isMetric]="false"
      [isAddPrefixRowId]="false"
      [isWrap]="false"
      [rowId]="params.data.rowId"
    ></m-row-metric-label>
  </div>
</div>

<div *ngIf="params.data.rowType === rowTypeMetric" class="font-ms">
  <div class="flex flex-col">
    <div
      class="hover:text-m500 flex max-w-min cursor-pointer truncate"
      (click)="showDialog($event)"
    >
      <m-row-metric-label
        [name]="params.value"
        [isMetric]="true"
        [isAddPrefixRowId]="false"
        [isWrap]="false"
        [rowId]="params.data.rowId"
        [showMetricsModelName]="showMetricsModelName"
        [showMetricsTimeFieldName]="showMetricsTimeFieldName"
        [partNodeLabel]="params.data.partNodeLabel"
        [connectionType]="params.data.query.connectionType"
        [partFieldLabel]="params.data.partFieldLabel"
        [timeNodeLabel]="params.data.timeNodeLabel"
        [timeFieldLabel]="params.data.timeFieldLabel"
        [topLabel]="params.data.topLabel"
        class="flex"
      ></m-row-metric-label
    ></div>

    <div
      class="flex flex-row"
      *ngIf="
        params.data.rowType === rowTypeMetric &&
        metric.type === metricTypeModel &&
        showParameters === true
      "
    >
      <div class="truncate">
        <div class="flex flex-shrink-0">
          <m-bricks
            class="flex max-w-max flex-shrink-0 flex-row items-end justify-start overflow-auto"
            [extendedFilters]="parametersFilters"
            [isKeepBackgroundColor]="true"
            [listen]="listen"
          ></m-bricks>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="uiQuery$ | async"></div>
